// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"LegacyModal2_modalBackdrop__CBq0H"};